import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import PhoneSessionLayout from '../../layouts/PhoneSessionLayout'
import PhoneSessionContent from './PhoneSessionContent'

export default class PhoneSession extends Component {
  render() {
    const { match } = this.props
    const { patientID } = match.params

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          <PhoneSessionLayout title="titles.phoneSession">
            <PhoneSessionContent />
          </PhoneSessionLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhoneSession/index.js